{
    "CAIS-Natural-Person-Quick-Search-Fields": [
        {
            "label": "Report Date", "columnname": "reportDate", "placeholder": "Report Date",
            "width": "", "datatype": "DateRange", "isLarge": false, "fieldtype": "maskfield", "mask": "9999-99-99", "slotchar": "yyyy-mm-dd"
        },
        {
            "label": "In Customer Record ID", "columnname": "inCustomerRecordID", "placeholder": "In Customer Record ID",
            "width": "", "datatype": "String", "isLarge": false, "isXLarge": true
        },
        {
            "label": "TID Value", "columnname": "tidValue", "placeholder": "TID Value",
            "width": "", "datatype": "String", "isLarge": false, "isXLarge": true
        }
    ],
    "CAISNaturalPersonCols": [
        {
            "display": "false",
            "ui_columnname": "Id",
            "db_columnname": "id",
            "datatype": "char",
            "mappingkey": "id",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 1
        },
        {
            "display": "true",
            "ui_columnname": "Action",
            "db_columnname": "rsmsStatus",
            "datatype": "char",
            "mappingkey": "rsmsStatus",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 2
        },
        {
            "display": "true",
            "ui_columnname": "Report Date",
            "db_columnname": "reportDate",
            "datatype": "String",
            "mappingkey": "reportDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 9
        },
        {
            "display": "false",
            "ui_columnname": "Firm",
            "db_columnname": "CATReporterIMID",
            "datatype": "String",
            "mappingkey": "CATReporterIMID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 3
        },
        {
            "display": "false",
            "ui_columnname": "Active",
            "db_columnname": "active",
            "datatype": "String",
            "mappingkey": "active",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 4
        },
        {
            "display": "false",
            "ui_columnname": "Report Reason",
            "db_columnname": "reportReason",
            "datatype": "String",
            "mappingkey": "reportReason",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 10
        },
        {
            "display": "true",
            "ui_columnname": "In Customer Record ID",
            "db_columnname": "inCustomerRecordID",
            "datatype": "String",
            "mappingkey": "inCustomerRecordID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 11
        },
        {
            "display": "true",
            "ui_columnname": "First Name",
            "db_columnname": "firstName",
            "datatype": "String",
            "mappingkey": "firstName",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "maxlength": "200",
            "isrequired": false,
            "sortOrder": 5
        },
        {
            "display": "true",
            "ui_columnname": "Middle Name",
            "db_columnname": "middleName",
            "datatype": "String",
            "mappingkey": "middleName",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "maxlength": "200",
            "sortOrder": 6
        },
        {
            "display": "true",
            "ui_columnname": "Last Name",
            "db_columnname": "lastName",
            "datatype": "String",
            "mappingkey": "lastName",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isrequired": false,
            "sortOrder": 7
        },
        {
            "display": "true",
            "ui_columnname": "Name Suffix",
            "db_columnname": "nameSuffix",
            "datatype": "String",
            "mappingkey": "nameSuffix",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [
                {
                    "label": "JUNIOR",
                    "value": "JUNIOR"
                },
                {
                    "label": "SENIOR",
                    "value": "SENIOR"
                },
                {
                    "label": "THIRD",
                    "value": "THIRD"
                },
                {
                    "label": "FIFTH",
                    "value": "FIFTH"
                },
                {
                    "label": "FOURTH",
                    "value": "FOURTH"
                }
            ],
            "sortOrder": 8
        },
        {
            "display": "true",
            "ui_columnname": "Year Of Birth",
            "db_columnname": "yearOfBirth",
            "datatype": "String",
            "mappingkey": "yearOfBirth",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "placeholder": "YYYY",
            "maxlength": "4",
            "isrequired": false,
            "regexpressions": ["^[1-2][8|9|0][0-9][0-9]$"],
            "sortOrder": 12
        },
        {
            "display": "true",
            "ui_columnname": "Doing Business As",
            "db_columnname": "doingBusinessAs",
            "datatype": "String",
            "mappingkey": "doingBusinessAs",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 13
        },
        {
            "display": "true",
            "ui_columnname": "TID Type",
            "db_columnname": "tidType",
            "datatype": "String",
            "mappingkey": "tidType",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [
                {
                    "label": "EIN",
                    "value": "EIN"
                },
                {
                    "label": "FOREIGN",
                    "value": "FOREIGN"
                },
                {
                    "label": "SSN/ITIN",
                    "value": "SSN/ITIN"
                }
            ],
            "isrequired": true,
            "sortOrder": 14
        },
        {
            "display": "true",
            "ui_columnname": "Foreign TID Type",
            "db_columnname": "foreignTIDType",
            "datatype": "String",
            "mappingkey": "foreignTIDType",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [
                {
                    "label": "LEI",
                    "value": "LEI"
                },
                {
                    "label": "NATIONALID",
                    "value": "NATIONALID"
                },
                {
                    "label": "PASSPORT",
                    "value": "PASSPORT"
                },
                {
                    "label": "PERMANENT",
                    "value": "PERMANENT"
                }
            ],
            "sortOrder": 15
        },
        {
            "display": "true",
            "ui_columnname": "Foreign TID Country",
            "db_columnname": "foreignTIDCountryCd",
            "datatype": "String",
            "mappingkey": "foreignTIDCountryCd",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [],
            "sortOrder": 16
        },
        {
            "display": "true",
            "ui_columnname": "Rep By TID Type",
            "db_columnname": "replacedByTIDType",
            "datatype": "String",
            "mappingkey": "replacedByTIDType",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [
                {
                    "label": "EIN",
                    "value": "EIN"
                },
                {
                    "label": "FOREIGN",
                    "value": "FOREIGN"
                },
                {
                    "label": "SSN/ITIN",
                    "value": "SSN/ITIN"
                }
            ],
            "sortOrder": 17
        },
        {
            "display": "true",
            "ui_columnname": "Rep by Foreign TID Type",
            "db_columnname": "replacingForeignTIDType",
            "datatype": "String",
            "mappingkey": "replacingForeignTIDType",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [
                {
                    "label": "LEI",
                    "value": "LEI"
                },
                {
                    "label": "NATIONALID",
                    "value": "NATIONALID"
                },
                {
                    "label": "PASSPORT",
                    "value": "PASSPORT"
                },
                {
                    "label": "PERMANENT",
                    "value": "PERMANENT"
                }
            ],
            "sortOrder": 18
        },
        {
            "display": "true",
            "ui_columnname": "Replacing Foreign TID Country",
            "db_columnname": "replacingForeignTIDCountryCd",
            "datatype": "String",
            "mappingkey": "replacingForeignTIDCountryCd",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [],
            "sortOrder": 19
        },
        
        {
            "display": "true",
            "ui_columnname": "Update Notification",
            "db_columnname": "updateNotification",
            "datatype": "String",
            "mappingkey": "updateNotification",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [
                {
                    "label": "Y",
                    "value": "Y"
                },
                {
                    "label": "N",
                    "value": "N"
                }
            ],
            "sortOrder": 20
        },
        {
            "display": "true",
            "ui_columnname": "TID Value",
            "db_columnname": "tidValue",
            "datatype": "String",
            "mappingkey": "tidValue",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isLargeFields": true,
            "isrequired": true,
            "sortOrder": 52
        },
        {
            "display": "true",
            "ui_columnname": "Rep By TID Value",
            "db_columnname": "replacedByTID",
            "datatype": "String",
            "mappingkey": "replacedByTID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isLargeFields": true,
            "sortOrder": 53
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 1.1",
            "db_columnname": "addr1_addrLine1",
            "datatype": "String",
            "mappingkey": "addr1_addrLine1",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 20
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 1.2",
            "db_columnname": "addr1_addrLine2",
            "datatype": "String",
            "mappingkey": "addr1_addrLine2",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 21
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 1.3",
            "db_columnname": "addr1_addrLine3",
            "datatype": "String",
            "mappingkey": "addr1_addrLine3",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 22
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 1.4",
            "db_columnname": "addr1_addrLine4",
            "datatype": "String",
            "mappingkey": "addr1_addrLine4",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 23
        },
        {
            "display": "true",
            "ui_columnname": "City 1",
            "db_columnname": "addr1_city",
            "datatype": "String",
            "mappingkey": "addr1_city",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 24
        },
        {
            "display": "true",
            "ui_columnname": "Region Code 1",
            "db_columnname": "addr1_regionCode",
            "datatype": "String",
            "mappingkey": "addr1_regionCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 25
        },
        {
            "display": "true",
            "ui_columnname": "Country Code 1",
            "db_columnname": "addr1_countryCode",
            "datatype": "String",
            "mappingkey": "addr1_countryCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 26
        },
        {
            "display": "true",
            "ui_columnname": "Postal Code 1",
            "db_columnname": "addr1_postalCode",
            "datatype": "String",
            "mappingkey": "addr1_postalCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "regexpressions": ["^(\\d{5})$", "^[ABCDEFGHIJKLMNOPQRSTUVWXYZ]\\d[ABCDEFGHIJKLMNOPQRSTUVWXYZ][ -]?\\d[ABCDEFGHIJKLMNOPQRSTUVWXYZ]\\d$"],
            "sortOrder": 27
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 2",
            "db_columnname": "addr2_addrLine2",
            "datatype": "String",
            "mappingkey": "addr2_addrLine1",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 28
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 2.2",
            "db_columnname": "addr2_addrLine2",
            "datatype": "String",
            "mappingkey": "addr2_addrLine2",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 29
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 2.3",
            "db_columnname": "addr2_addrLine3",
            "datatype": "String",
            "mappingkey": "addr2_addrLine3",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 30
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 2.4",
            "db_columnname": "addr2_addrLine4",
            "datatype": "String",
            "mappingkey": "addr2_addrLine4",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 31
        },
        {
            "display": "true",
            "ui_columnname": "City 2",
            "db_columnname": "addr2_city",
            "datatype": "String",
            "mappingkey": "addr2_city",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 32
        },
        {
            "display": "true",
            "ui_columnname": "Region Code 2",
            "db_columnname": "addr2_regionCode",
            "datatype": "String",
            "mappingkey": "addr2_regionCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 33
        },
        {
            "display": "true",
            "ui_columnname": "Country Code 2",
            "db_columnname": "addr2_countryCode",
            "datatype": "String",
            "mappingkey": "addr2_countryCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 34
        },
        {
            "display": "true",
            "ui_columnname": "Postal Code 2",
            "db_columnname": "addr2_postalCode",
            "datatype": "String",
            "mappingkey": "addr2_postalCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "regexpressions": ["^(\\d{5})$", "^[ABCDEFGHIJKLMNOPQRSTUVWXYZ]\\d[ABCDEFGHIJKLMNOPQRSTUVWXYZ][ -]?\\d[ABCDEFGHIJKLMNOPQRSTUVWXYZ]\\d$"],
            "sortOrder": 35
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 3",
            "db_columnname": "addr3_addrLine1",
            "datatype": "String",
            "mappingkey": "addr3_addrLine1",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 36
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 3.2",
            "db_columnname": "addr3_addrLine2",
            "datatype": "String",
            "mappingkey": "addr3_addrLine2",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 37
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 3.3",
            "db_columnname": "addr3_addrLine3",
            "datatype": "String",
            "mappingkey": "addr3_addrLine3",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 38
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 3.4",
            "db_columnname": "addr3_addrLine4",
            "datatype": "String",
            "mappingkey": "addr3_addrLine4",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 39
        },
        {
            "display": "true",
            "ui_columnname": "City 3",
            "db_columnname": "addr3_city",
            "datatype": "String",
            "mappingkey": "addr3_city",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 40
        },
        {
            "display": "true",
            "ui_columnname": "Region Code 3",
            "db_columnname": "addr3_regionCode",
            "datatype": "String",
            "mappingkey": "addr3_regionCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 41
        },
        {
            "display": "true",
            "ui_columnname": "Country Code 3",
            "db_columnname": "addr3_countryCode",
            "datatype": "String",
            "mappingkey": "addr3_countryCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 42
        },
        {
            "display": "true",
            "ui_columnname": "Postal Code 3",
            "db_columnname": "addr3_postalCode",
            "datatype": "String",
            "mappingkey": "addr3_postalCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "regexpressions": ["^(\\d{5})$", "^[ABCDEFGHIJKLMNOPQRSTUVWXYZ]\\d[ABCDEFGHIJKLMNOPQRSTUVWXYZ][ -]?\\d[ABCDEFGHIJKLMNOPQRSTUVWXYZ]\\d$"],
            "sortOrder": 43
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 4",
            "db_columnname": "addr4_addrLine1",
            "datatype": "String",
            "mappingkey": "addr4_addrLine1",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 44
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 4.2",
            "db_columnname": "addr4_addrLine2",
            "datatype": "String",
            "mappingkey": "addr4_addrLine2",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 45
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 4.3",
            "db_columnname": "addr4_addrLine3",
            "datatype": "String",
            "mappingkey": "addr4_addrLine3",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 46
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 4.4",
            "db_columnname": "addr4_addrLine4",
            "datatype": "String",
            "mappingkey": "addr4_addrLine4",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 47
        },
        {
            "display": "true",
            "ui_columnname": "City 4",
            "db_columnname": "addr4_city",
            "datatype": "String",
            "mappingkey": "addr4_city",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 48
        },
        {
            "display": "true",
            "ui_columnname": "Region Code 4",
            "db_columnname": "addr4_regionCode",
            "datatype": "String",
            "mappingkey": "addr4_regionCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 49
        },
        {
            "display": "true",
            "ui_columnname": "Country Code 4",
            "db_columnname": "addr4_countryCode",
            "datatype": "String",
            "mappingkey": "addr4_countryCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 50
        },
        {
            "display": "true",
            "ui_columnname": "Postal Code 4",
            "db_columnname": "addr4_postalCode",
            "datatype": "String",
            "mappingkey": "addr4_postalCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "regexpressions": ["^(\\d{5})$", "^[ABCDEFGHIJKLMNOPQRSTUVWXYZ]\\d[ABCDEFGHIJKLMNOPQRSTUVWXYZ][ -]?\\d[ABCDEFGHIJKLMNOPQRSTUVWXYZ]\\d$"],
            "sortOrder": 51
        },
        {
            "display": "true",
            "ui_columnname": "Created Date",
            "db_columnname": "createdDate",
            "datatype": "String",
            "mappingkey": "createdDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 54
        },
        {
            "display": "true",
            "ui_columnname": "Created User",
            "db_columnname": "createdUser",
            "datatype": "String",
            "mappingkey": "createdUser",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 55
        },
        {
            "display": "true",
            "ui_columnname": "Updated User",
            "db_columnname": "updatedUser",
            "datatype": "String",
            "mappingkey": "updatedUser",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 56
        },
        {
            "display": "true",
            "ui_columnname": "Updated Date",
            "db_columnname": "updatedDate",
            "datatype": "String",
            "mappingkey": "updatedDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": false,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "sortOrder": 57
        }
    ],
    "AddressesDataCols": [
        {
            "display": "true",
            "ui_columnname": "Address Line 1",
            "db_columnname": "addr_addrLine1",
            "datatype": "String",
            "mappingkey": "addr_addrLine1",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isrequired": false,
            "maxlength": "40",
            "regexpressions": ["^([\\s+\\w-'/`~!#*$@_%+=.,^&(){}[]|;:\"<>?\\]){0,40}$"]
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 2",
            "db_columnname": "addr_addrLine2",
            "datatype": "String",
            "mappingkey": "addr_addrLine2",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "maxlength": "40",
            "regexpressions": ["^([\\s+\\w-'/`~!#*$@_%+=.,^&(){}[]|;:\"<>?\\]){0,40}$"]
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 3",
            "db_columnname": "addr_addrLine3",
            "datatype": "String",
            "mappingkey": "addr_addrLine3",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "maxlength": "40",
            "regexpressions": ["^([\\s+\\w-'/`~!#*$@_%+=.,^&(){}[]|;:\"<>?\\]){0,40}$"]
        },
        {
            "display": "true",
            "ui_columnname": "Address Line 4",
            "db_columnname": "addr_addrLine4",
            "datatype": "String",
            "mappingkey": "addr_addrLine4",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "maxlength": "40",
            "regexpressions": ["^([\\s+\\w-'/`~!#*$@_%+=.,^&(){}[]|;:\"<>?\\]){0,40}$"]
        },
        {
            "display": "true",
            "ui_columnname": "City",
            "db_columnname": "addr_city",
            "datatype": "String",
            "mappingkey": "addr_city",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "isrequired": false
        },
        {
            "display": "true",
            "ui_columnname": "Region Code",
            "db_columnname": "addr_regionCode",
            "datatype": "String",
            "mappingkey": "addr_regionCode",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": []
        },
        {
            "display": "true",
            "ui_columnname": "Country Code",
            "db_columnname": "addr_countryCode",
            "datatype": "String",
            "mappingkey": "addr_countryCode",
            "dropdown": "YES",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": [],
            "isrequired": false
        },
        {
            "display": "true",
            "ui_columnname": "Postal Code",
            "db_columnname": "addr_postalCode",
            "datatype": "String",
            "mappingkey": "addr_postalCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": true,
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": "",
            "regexpressions": ["^(\\d{5})$", "^[ABCDEFGHIJKLMNOPQRSTUVWXYZ]\\d[ABCDEFGHIJKLMNOPQRSTUVWXYZ][ -]?\\d[ABCDEFGHIJKLMNOPQRSTUVWXYZ]\\d$"]
        }
    ]
}